module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n        Timeline\n        "), _c('small', [_vm._v("example")])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("UI")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Timeline")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('ul', {
    staticClass: "timeline"
  }, [_c('li', {
    staticClass: "time-label"
  }, [_c('span', {
    staticClass: "bg-red"
  }, [_vm._v("\n                    10 Feb. 2014\n                  ")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-envelope bg-blue"
  }), _vm._v(" "), _c('div', {
    staticClass: "timeline-item"
  }, [_c('span', {
    staticClass: "time"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 12:05")]), _vm._v(" "), _c('h3', {
    staticClass: "timeline-header"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Support Team")]), _vm._v(" sent you an email")]), _vm._v(" "), _c('div', {
    staticClass: "timeline-body"
  }, [_vm._v("\n                  Etsy doostang zoodles disqus groupon greplin oooj voxy zoodles,\n                  weebly ning heekya handango imeem plugg dopplr jibjab, movity\n                  jajah plickers sifteo edmodo ifttt zimbra. Babblely odeo kaboodle\n                  quora plaxo ideeli hulu weebly balihoo...\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "timeline-footer"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-xs"
  }, [_vm._v("Read more")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger btn-xs"
  }, [_vm._v("Delete")])])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-user bg-aqua"
  }), _vm._v(" "), _c('div', {
    staticClass: "timeline-item"
  }, [_c('span', {
    staticClass: "time"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 5 mins ago")]), _vm._v(" "), _c('h3', {
    staticClass: "timeline-header no-border"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sarah Young")]), _vm._v(" accepted your friend request")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-comments bg-yellow"
  }), _vm._v(" "), _c('div', {
    staticClass: "timeline-item"
  }, [_c('span', {
    staticClass: "time"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 27 mins ago")]), _vm._v(" "), _c('h3', {
    staticClass: "timeline-header"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Jay White")]), _vm._v(" commented on your post")]), _vm._v(" "), _c('div', {
    staticClass: "timeline-body"
  }, [_vm._v("\n                  Take me to your leader!\n                  Switzerland is small and neutral!\n                  We are more like Germany, ambitious and misunderstood!\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "timeline-footer"
  }, [_c('a', {
    staticClass: "btn btn-warning btn-flat btn-xs"
  }, [_vm._v("View comment")])])])]), _vm._v(" "), _c('li', {
    staticClass: "time-label"
  }, [_c('span', {
    staticClass: "bg-green"
  }, [_vm._v("\n                    3 Jan. 2014\n                  ")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-camera bg-purple"
  }), _vm._v(" "), _c('div', {
    staticClass: "timeline-item"
  }, [_c('span', {
    staticClass: "time"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 2 days ago")]), _vm._v(" "), _c('h3', {
    staticClass: "timeline-header"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Mina Lee")]), _vm._v(" uploaded new photos")]), _vm._v(" "), _c('div', {
    staticClass: "timeline-body"
  }, [_c('img', {
    staticClass: "margin",
    attrs: {
      "src": "http://placehold.it/150x100",
      "alt": "..."
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "margin",
    attrs: {
      "src": "http://placehold.it/150x100",
      "alt": "..."
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "margin",
    attrs: {
      "src": "http://placehold.it/150x100",
      "alt": "..."
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "margin",
    attrs: {
      "src": "http://placehold.it/150x100",
      "alt": "..."
    }
  })])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-video-camera bg-maroon"
  }), _vm._v(" "), _c('div', {
    staticClass: "timeline-item"
  }, [_c('span', {
    staticClass: "time"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 5 days ago")]), _vm._v(" "), _c('h3', {
    staticClass: "timeline-header"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Mr. Doe")]), _vm._v(" shared a video")]), _vm._v(" "), _c('div', {
    staticClass: "timeline-body"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": "https://www.youtube.com/embed/tMWkeBIohBs",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "timeline-footer"
  }, [_c('a', {
    staticClass: "btn btn-xs bg-maroon",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("See comments")])])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-clock-o bg-gray"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-code"
  }), _vm._v(" Timeline Markup")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('pre', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("<ul class=\"timeline\">\n\n    <!-- timeline time label -->\n    <li class=\"time-label\">\n        <span class=\"bg-red\">\n            10 Feb. 2014\n        </span>\n    </li>\n    <!-- /.timeline-label -->\n\n    <!-- timeline item -->\n    <li>\n        <!-- timeline icon -->\n        <i class=\"fa fa-envelope bg-blue\"></i>\n        <div class=\"timeline-item\">\n            <span class=\"time\"><i class=\"fa fa-clock-o\"></i> 12:05</span>\n\n            <h3 class=\"timeline-header\"><a href=\"#\">Support Team</a> ...</h3>\n\n            <div class=\"timeline-body\">\n                ...\n                Content goes here\n            </div>\n\n            <div class=\"timeline-footer\">\n                <a class=\"btn btn-primary btn-xs\">...</a>\n            </div>\n        </div>\n    </li>\n    <!-- END timeline item -->\n\n    ...\n\n</ul>\n                  ")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2b7b24a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/ui/Timeline.vue
// module id = 1900
// module chunks = 1